import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  image: {
    paddingTop: 20,
    width: '100%',
  },
  bottomImage: {
    padding: 0,
    width: '80%',
    marginLeft: '10%',
  },
  headerImage: {
    display: 'block',
    width: '100%',
  },
}));

const AcquisitionPage08 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.grayBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[1].ACQUISITION_STEP_5.path}`}
          alt={`${IMAGE_PATHS.STEPS[1].ACQUISITION_STEP_5.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 5:</Typography>
          <Typography variant="h3">Image Reconstruction</Typography>
          <img
            className={classNames(classes.image, classes.bottomImage)}
            src={`${BASE_URL}${IMAGE_PATHS.AXUMIN_IMAGE_ACQ_CLIP.path}`}
            alt={`${IMAGE_PATHS.AXUMIN_IMAGE_ACQ_CLIP.alt}`}
          />
        </div>
      </div>
    </>
  );
};

export default AcquisitionPage08;
